module.exports = "<div class=\"navbar-button ripple\">\n    <i class=\"icon-{{ icon }}\" style=\"padding-right: 6px;\"></i> <span *ngIf=\"label\"> {{ label | uppercase }} </span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/component/core/topbar-button/topbar-button.component.html
// module id = 1097
// module chunks = 0